import axios from '../utils/axios';
import config from '../utils/config';

const BUSINESS_ACCOUNTS_URL = config.get('dashboard_api', 'business_accounts');
const AD_ACCOUNTS_URL = config.get('dashboard_api', 'ad_accounts');
const AD_ACCOUNT_URL = config.get('dashboard_api', 'ad_account');
const AD_ENTITIES = config.get('dashboard_api', 'ad_entities');
const AD_ENTITIES_SEARCH = config.get('dashboard_api', 'ad_entities_search');
const SLACK_SUBSCRIBE = config.get('dashboard_api', 'slack_subscribe');
const GET_RULES_URL = config.get('dashboard_api', 'rules');
const REPORT_LIST_URL = config.get('dashboard_api', 'report_list');
const SHARED_REPORT_LIST = config.get('dashboard_api', 'shared_report_list');
const UPDATE_REPORT = config.get('report_api', 'update_report');
const DELETE_REPORT = config.get('report_api', 'delete_report');
const USERS_LIST_URL = config.get('dashboard_api', 'user_list');
const DETAIL_VIEW_REPORT = config.get('report_api', 'detail_view_report');
const COUNTRY_URL = config.get('dashboard_api', 'country_list');
const INDUSTRY_URL = config.get('dashboard_api', 'industry_list');
const ADVERTISERS_URL = config.get('dashboard_api', 'advertisers_list');
const SUB_VERTICALS_URL = config.get('dashboard_api', 'sub_vertical_list');
const KPI_URL = config.get('dashboard_api', 'kpi_list');
const KPI_URL_EFFICIENCY = config.get('dashboard_api', 'kpi_list_efficiency');
const BM_LIST_URL = config.get('import_analysis_api', 'bm_list');
const Ad_Account_LIST_URL = config.get('import_analysis_api', 'ad_account_list');
const CAMPAIGNS_LIST_URL = config.get('import_analysis_api', 'campaigns_list');
const GET_CAMPAIGNS_LIST_URL = config.get('import_analysis_api', 'list_campaigns');
const ADV_AD_ACCOUNT_LIST_URL = config.get('import_analysis_api', 'adv_ad_account_list');
const STRATEGIC_ATTRIBUTES_URL = config.get('dashboard_api', 'strategic_attr_list');
const LIST_IMPORTED_CAMPAIGN = config.get('import_analysis_api', 'list_imported_campaigns');
const IMPORT_SELECTED_URL = config.get('imported_campaigns_post', 'import_selected');
const AD_ACCOUNT_ADVERTISER = config.get('report_api', 'ad_accounts_advertisers');
const TRACK_USAGE = config.get('track-usage', "usage");

async function getBusinessAccounts(accessToken, username) {
  try {
    const businessAccountsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: BUSINESS_ACCOUNTS_URL,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return businessAccountsResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getAdAccounts(accessToken, username, data) {
  const { businessAccountId, evaluation } = data;

  try {
    const adAccountsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(AD_ACCOUNTS_URL, businessAccountId),
      params: {
        ...(evaluation && { evaluation: evaluation }),
      },
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adAccountsResponse;
  } catch (error) {
    throw error.response;
  }
}

async function pauseAdset(accessToken, username, data) {
  const { businessAccountId, adAccountId, pauseAdset, refreshFlag } = data;

  try {
    const pauseAdSetResponse = await axios({
      method: 'patch',
      responseType: 'json',
      url: config.formUrl(AD_ACCOUNT_URL, businessAccountId, adAccountId),
      data: {
        pauseAdset,
        refreshFlag,
      },
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return pauseAdSetResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getAdEntities(accessToken, username, data) {
  const { businessAccountId, adAccountId } = data;

  try {
    const adEntitiesResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(AD_ENTITIES, businessAccountId, adAccountId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adEntitiesResponse;
  } catch (error) {
    throw error.response;
  }
}

async function searchAdEntities(accessToken, username, data) {
  const { businessAccountId, adAccountId, like } = data;

  try {
    const searchAdEntitiesResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(AD_ENTITIES_SEARCH, businessAccountId, adAccountId),
      params: {
        like,
      },
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return searchAdEntitiesResponse;
  } catch (error) {
    throw error.response;
  }
}

async function slackSubscribe(accessToken, username, data) {
  const { businessAccountId, adAccountId } = data;

  try {
    const slackSubscribeResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(SLACK_SUBSCRIBE, businessAccountId, adAccountId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return slackSubscribeResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getRules(accessToken) {
  try {
    const getRulesResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(GET_RULES_URL),
      headers: {
        'x-access-token': accessToken,
      },
    });
    return getRulesResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getSharedReports(accessToken, username, type, searchQuery) {
  try {
    const getReportsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: `${config.formUrl(SHARED_REPORT_LIST)}?searchField=${type}&searchText=${searchQuery}`,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getReportsResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getReports(accessToken, username, type, searchQuery) {
  try {
    const getReportsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: `${config.formUrl(REPORT_LIST_URL)}?searchField=${type}&searchText=${searchQuery}`,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getReportsResponse;
  } catch (error) {
    throw error.response;
  }
}
async function getUsersList(accessToken, username) {
  try {
    const getUserlistResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(USERS_LIST_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getUserlistResponse;
  } catch (error) {
    throw error.response;
  }
}

async function updateReport(accessToken, username, data) {
  const { reportId, reportData } = data;
  //console.log(reportData);
  try {
    const updateReportResponse = await axios({
      method: 'put',
      responseType: 'json',
      url: config.formUrl(UPDATE_REPORT, reportId),
      data: reportData,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function deleteReport(accessToken, username, data) {
  try {
    const updateReportResponse = await axios({
      method: 'put',
      responseType: 'json',
      url: config.formUrl(DELETE_REPORT),
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function detailViewReport(accessToken, username, data) {
  const { reportId } = data;
  try {
    const updateReportResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(DETAIL_VIEW_REPORT, reportId),
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function countryList(accessToken, username) {
  try {
    const countryListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(COUNTRY_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return countryListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function advertiserList(accessToken, username) {
  try {
    const advertiserListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(ADVERTISERS_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return advertiserListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function industryList(accessToken, username) {
  try {
    const industryListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(INDUSTRY_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return industryListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function subVerticalList(accessToken, username) {
  try {
    const subVerticalResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(SUB_VERTICALS_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return subVerticalResponse;
  } catch (error) {
    throw error.response;
  }
}

async function kpiList(accessToken, username, campaignId, is_optimization = false) {
  let url = is_optimization ? `${config.formUrl(KPI_URL, campaignId)}?is_for_optimization=${is_optimization}` : config.formUrl(KPI_URL, campaignId);
  try {
    const kpiListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return kpiListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function kpiListEfficiency(accessToken, username, is_for_insights = true) {
  try {
    const kpiListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(KPI_URL_EFFICIENCY) + '?is_for_insights=' + is_for_insights,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return kpiListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function bmList(accessToken, username) {
  try {
    const bmListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(BM_LIST_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return bmListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function adAccountList(accessToken, username, businessManagerId) {
  try {
    const adAccountListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(Ad_Account_LIST_URL, businessManagerId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adAccountListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function campaignsList(accessToken, username, adAccountId) {
  try {
    const adAccountListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: `${CAMPAIGNS_LIST_URL}?adAccounts=${adAccountId}&type=live`,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adAccountListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getCampaignsList(accessToken, username, data) {
  try {
    const adAccountListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(GET_CAMPAIGNS_LIST_URL, data),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adAccountListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function advertiserAdaccountList(accessToken, username, advertiser) {
  try {
    const adAccountListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(ADV_AD_ACCOUNT_LIST_URL, advertiser),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adAccountListResponse;
  } catch (error) {
    throw error.response;
  }
}

async function strategicAttrList(accessToken, username) {
  try {
    const strategicAttrResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(STRATEGIC_ATTRIBUTES_URL),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return strategicAttrResponse;
  } catch (error) {
    throw error.response;
  }
}

async function importSelected(accessToken, username, data) {
  try {
    const importSelectedResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: IMPORT_SELECTED_URL,
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return importSelectedResponse;
  } catch (error) {
    throw error.response;
  }
}

async function listImportedCampaign(requestData) {
  const {
    accessToken,
    username,
    adAccountId,
    type,
    limit,
    page,
    sortType,
    sortColumn,
    searchKeyword,
    filterBy,
  } = requestData;
  let URL = `/${adAccountId}/${type}/list?recordsPerPage=${limit}&page=${page}&searchText=${searchKeyword}&searchFields=${filterBy}`;
  if (sortType && sortColumn) {
    URL = URL + `&sortBy=${sortColumn}&order=${sortType}`;
  }
  try {
    const importedCampaign = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(LIST_IMPORTED_CAMPAIGN) + URL,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return importedCampaign;
  } catch (error) {
    throw error.response;
  }
}

async function getAdAccountsForAdvertisers(accessToken, username, advertiser) {
  try {
    const adAccountsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.advertiserUrl('/user/{advertiser}/accounts', advertiser),
      params: {
        advertiser,
      },
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return adAccountsResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getReportsForAdaccount(accessToken, username, advertiser, adAccountId, reportType, searchKeyword, dropdownFilterby, recordsPerPage, page,
  sortBy, order) {
  let url = `/reporting/reports/${reportType}?advertiser=${advertiser}&adAccount=${adAccountId}&recordsPerPage=${recordsPerPage}&page=${page}`;
  if (searchKeyword) {
    url = url + `&searchText=${searchKeyword}&searchFields=${dropdownFilterby}`;
  }
  if (sortBy) {
    url = url + `&sortBy=${sortBy}&order=${order}`;
  }
  try {
    const reportResponseData = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      }
    });
    return reportResponseData;
  } catch (error) {
    throw error.response;
  }
}

export const getMetaCatalogPDFs = async (
  accessToken,
  username,
  recordsPerPage,
  page,
  searchText = ""
) => {
  const url =
    `${process.env.REACT_APP_MALA_URL}/api/admin/meta-catalogs/list` +
    `?recordsPerPage=${recordsPerPage}&page=${page}&searchText=${searchText}&searchFields=fileName`
    try {
      const response = await axios({
        method:'get',
        responseType:'json',
        url: url,
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        }
      })
  
      return response.data.data;
    } catch (error) {
      throw error.response
    }
}

async function getReportData(accessToken, username, reportId) {
  let url = `/reporting/request/${reportId}`;
  try {
    const reportData = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      }
    });
    return reportData;
  } catch (error) {
    throw error.response;
  }
}

async function postTrackUsageAPI(accessToken, username, payload) {
  const url = TRACK_USAGE;

  try {
    const trackUsageCall = await axios({
      method: "post",
      url,
      data: payload,
      headers: {
        "x-access-token": accessToken,
        "x-user": username,
      }

    })
    return trackUsageCall
  } catch (error) {
    throw error.response;
  }
}

export {
  getBusinessAccounts,
  getAdAccounts,
  pauseAdset,
  getAdEntities,
  searchAdEntities,
  slackSubscribe,
  getRules,
  getReports,
  updateReport,
  getUsersList,
  getSharedReports,
  deleteReport,
  detailViewReport,
  countryList,
  industryList,
  advertiserList,
  kpiList,
  bmList,
  adAccountList,
  campaignsList,
  advertiserAdaccountList,
  strategicAttrList,
  importSelected,
  listImportedCampaign,
  kpiListEfficiency,
  getAdAccountsForAdvertisers,
  getCampaignsList,
  getReportsForAdaccount,
  getReportData,
  subVerticalList,
  postTrackUsageAPI
}
